export default __webpack_public_path__ + "static/media/trip-arrow.ec603c88.svg";